<template>
    <DetailsSection v-if="newsletterEnabled && !subscribedToNewsletter">
        <template slot="header">
            {{ $t('Newsletter.section.header') }}
        </template>

        <div class="newsletter-section">
            <NewsletterBadge class="newsletter-section__badge">
                <translate
                    v-if="!success || alreadySubscribed"
                    path="Newsletter.badge"
                    :params="{ amount: newsletterDiscountInEuro }"
                    key="badge-init"
                />
                <translate v-else path="Newsletter.success.badge" key="badge-success" />
            </NewsletterBadge>

            <NewsletterForm
                :button-text="$t('Newsletter.button.mobile')"
                class="newsletter-section__form"
                :source="source"
                @success="success = $event"
                @response:already-subscribed="alreadySubscribed = $event"
            >
            </NewsletterForm>
        </div>
    </DetailsSection>
</template>

<script>
import NewsletterForm from '@/components/newsletter/NewsletterForm';
import NewsletterBadge from '@/components/newsletter/NewsletterBadge';
import DetailsSection from '@/components/DetailsSection';
export default {
    name: 'NewsletterSection',
    components: { DetailsSection, NewsletterBadge, NewsletterForm },
    props: {
        source: {
            type: String
        }
    },
    data() {
        return {
            success: false,
            alreadySubscribed: false
        };
    },
    computed: {
        subscribedToNewsletter() {
            return this.$store.getters.referredByNewsletter;
        },
        newsletterEnabled() {
            return this.$store.state.globalMeta.newsletterFormEnabled;
        },
        newsletterDiscountInEuro() {
            return this.$store.state.globalMeta.newsletterDiscount / 100;
        }
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/bootstrap/breakpoints' as breakpoints;

.newsletter-section {
    padding-top: 38px;
    position: relative;

    &__badge {
        position: absolute;
        top: 0;
        z-index: 3;
        left: 15px;
    }

    &__form {
        max-width: 100% !important;
        display: block !important;
        text-align: center;

        ::v-deep {
            .newsletter-form__input-group,
            .newsletter-form__success-text {
                background-color: var(--footer-bg-color);
            }

            .newsletter-form__input-group {
                padding: 60px 30px;
                padding-bottom: 20px;
                display: flex;
                margin-bottom: 20px;
            }

            .form-group {
                flex: 1 0 auto;
                margin-right: 30px;
            }

            .newsletter-form__button {
                display: inline-block;
                width: auto;
            }

            .newsletter-form__notice {
                font-weight: bold;
            }

            .newsletter-form__info {
                line-height: 1.2;
                display: inline-block;
                color: var(--muted-accessible);
            }

            .newsletter-form__success-text {
                color: var(--footer-header-color);
                max-width: 100%;
            }

            @include breakpoints.media-breakpoint-down(xs) {
                .newsletter-form__input-group {
                    flex-direction: column;
                }

                .form-group {
                    margin-right: 0;
                }
            }
        }
    }
}
</style>
